import { useEffect } from "react";

/**
 * Paints the continuous warm-pink canvas by adding `bopay-dash-body` to
 * <body>, and removes it when the last consumer unmounts.
 *
 * Several components may need the canvas at once (the nav, plus a screen that
 * renders without the nav). A naive add-on-mount / remove-on-unmount effect in
 * each of them breaks when two are mounted together: whichever unmounts first
 * strips the class while the other still needs it, flashing the page white.
 * Reference-counting fixes that — the class is removed only when the count
 * returns to zero.
 */
let canvasRefCount = 0;
let onboRefCount = 0;

export default function useBopayCanvas() {
  useEffect(() => {
    canvasRefCount += 1;
    document.body.classList.add("bopay-dash-body");

    return () => {
      canvasRefCount -= 1;
      if (canvasRefCount <= 0) {
        canvasRefCount = 0;
        document.body.classList.remove("bopay-dash-body");
      }
    };
  }, []);
}

/**
 * Same reference-counted treatment for the login / auth screens, which render
 * outside the admin shell and therefore never receive `bopay-dash-body`.
 */
export function useBopayOnboardingCanvas() {
  useEffect(() => {
    onboRefCount += 1;
    document.body.classList.add("bopay-onbo-body");

    return () => {
      onboRefCount -= 1;
      if (onboRefCount <= 0) {
        onboRefCount = 0;
        document.body.classList.remove("bopay-onbo-body");
      }
    };
  }, []);
}
